<template>
  <div class="switch-camera-btn" @click="$emit('click')" @touchstart="isPressed = true" @touchend="isPressed = false"
    @touchcancel="isPressed = false" @mousedown="isPressed = true" @mouseup="isPressed = false"
    @mouseleave="isPressed = false">
    <img :src="require('../../assets/common/switch-camera.svg')" :class="{ 'pressed': isPressed }">
  </div>
</template>

<script>
export default {
  name: 'SwitchCameraButton',
  data: () => ({
    isPressed: false
  })
}
</script>

<style lang="scss" scoped>
.switch-camera-btn {

  img {
    width: 60px;
    height: 45px;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;

    &.pressed {
      content: url('../../assets/common/switch-camera-pressed.svg');
    }
  }
}
</style>
